import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import React, { Fragment } from "react";
import { ButtonSecondaryModal } from "../atoms/ButtonSecondaryModal";
import { PlusIcon } from "@heroicons/react/20/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { ButtonPrimaryModal } from "../atoms/ButtonPrimaryModal";
import { t } from "i18next";

import { faCloudArrowDown } from "@fortawesome/pro-regular-svg-icons";

import { ButtonPrimary } from "@/shared/components/atoms/ButtonPrimary";

import { Branch } from "@/app/branchs/branchs.type";
import { Select } from "@/shared/components/organisms/Select";
import { Option } from "@/shared/components/molecules/OptionsSelect";
import { classNames } from "@/shared/utils/classnames";

type ModalXXLProps = {
  onClickCreate?: () => void;
  Close: () => void;
  open: boolean;
  textButtonCreate?: string;
  textButtonClose?: string;
  children?: React.ReactNode;
  tittleModal: string;
  functionButtonTopCreate?: () => void;
  functionButtonEdit?: () => void;
  functionButtonDelete?: () => void;
  functionButtonHabilitarCoutas?: () => void;
  canCreate?: boolean;
  canEdit?: boolean;
  canDelete?: boolean;

  branchSelected?: Option;
  setBranchSelected?: (option: Option) => void;
  branchesOptions?: Option[];
  branches?: Branch[];

  handleExport?: () => void;
  openModal?: () => void;
  isLoading?: boolean;
  disabledCreated?: boolean;
  modalClassName?: string;
};

export const ModalXXL: React.FC<ModalXXLProps> = ({
  onClickCreate,
  Close,
  open,
  textButtonCreate,
  textButtonClose,
  children,
  tittleModal,
  canCreate = true,
  canEdit = true,
  canDelete = true,
  functionButtonTopCreate,
  functionButtonEdit,
  functionButtonDelete,
  functionButtonHabilitarCoutas,
  modalClassName,
  isLoading,
  disabledCreated,

  branchSelected,
  setBranchSelected,
  branchesOptions,
  branches,

  handleExport,
  openModal,
}) => (
  <Fragment>
    <Dialog
      open={open}
      onClose={Close}
      className={classNames("relative z-10", modalClassName)}
    >
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-visible rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 w-full sm:max-w-xl lg:max-w-5xl data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4 rounded-t-sm">
              <div className="">
                <div className="mt-3 sm:ml-0 sm:mt-0">
                  <div className="flex justify-between items-center">
                    <div className="bg-gray-50 px-4 py-6 sm:px-6">
                      <div className="flex items-start justify-between space-x-3">
                        <div className="space-y-1">
                          <DialogTitle
                            as="h3"
                            className="text-base font-semibold leading-6 text-gray-900"
                          >
                            {tittleModal}
                          </DialogTitle>
                        </div>

                        {/*
                        <div className="relative">
                          <button
                            type="button"
                            className="text-gray-400 hover:text-gray-500 hidden md:block"
                          >
                            <span className="sr-only">Export</span>
                            <FontAwesomeIcon
                              icon={faCloudArrowDown}
                              aria-hidden="true"
                              className="h-10 w-10"
                              onClick={handleExport}
                            />
                          </button>
                        </div>

                        <ButtonPrimary
                          text={'Definir porcentajes de ocupación para el semáforo'}
                          size="small-xs"
                          onClick={openModal}
                        />

                        {branchesOptions && (
                          <Select
                            name="branch"
                            selected={branchSelected}
                            setSelected={setBranchSelected}
                            options={branchesOptions}
                            tittle={''}
                          />
                        )}
                        */}
                      </div>
                    </div>

                    {/* Contenedor para agrupar y alinear los botones */}
                    <div className="flex items-center space-x-2">
                      {functionButtonHabilitarCoutas !== undefined && (
                        <button
                          onClick={() => {}}
                          type="button"
                          className="block rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                        >
                          Habilitar pagos online
                        </button>
                      )}
                      {functionButtonTopCreate !== undefined && canCreate && (
                        <button
                          onClick={functionButtonTopCreate}
                          type="button"
                          className="block rounded-full border-2 border-dashed border-gray-400 p-1 text-gray-400 shadow-sm hover:text-gray-500 focus-visible:outline-none"
                        >
                          <PlusIcon aria-hidden="true" className="h-4 w-4" />
                        </button>
                      )}
                      {functionButtonDelete !== undefined && canDelete && (
                        <a
                          onClick={functionButtonDelete}
                          href="#"
                          className="text-red-600 hover:text-red-900 mr-4"
                        >
                          <FontAwesomeIcon icon={faTrashCan} />
                          <span className="sr-only"></span>
                        </a>
                      )}
                    </div>
                  </div>
                  <div className="mt-2">{children}</div>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse gap-2 sm:px-6 rounded-b-sm">
              <Fragment>
                {textButtonCreate === undefined ? (
                  <></>
                ) : (
                  <ButtonPrimaryModal
                    text={textButtonCreate}
                    onClick={onClickCreate}
                  />
                )}
                {textButtonClose === undefined ? (
                  <></>
                ) : (
                  <ButtonSecondaryModal
                    text={textButtonClose}
                    onClick={Close}
                  />
                )}
                {functionButtonEdit !== undefined && canEdit ? (
                  <a
                    onClick={functionButtonEdit}
                    href="#"
                    className="inline-flex w-full justify-center text-sm font-semibold ring-gray-300 sm:w-auto text-primary-600 hover:text-primary-900 mr-6 mt-2"
                  >
                    {t("general.edit")}
                    <span className="sr-only"></span>
                  </a>
                ) : (
                  <></>
                )}
              </Fragment>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  </Fragment>
);
